function parseDate(dateStr: string | null | undefined): Date | null {
  if (!dateStr) return null;
  const parts = dateStr.split('-').map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return null;
  const [y, m, d] = parts;
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatDate(dateStr: string | null | undefined): string {
  const date = parseDate(dateStr);
  if (!date) return '-';
  return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
}

export function formatDateShort(dateStr: string | null | undefined): string {
  const date = parseDate(dateStr);
  if (!date) return '-';
  return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
}

export function getWeekday(dateStr: string | null | undefined): string {
  const date = parseDate(dateStr);
  if (!date) return '-';
  return date.toLocaleDateString('tr-TR', { weekday: 'long' });
}

export function getWeekdayShort(dateStr: string | null | undefined): string {
  const date = parseDate(dateStr);
  if (!date) return '-';
  return date.toLocaleDateString('tr-TR', { weekday: 'short' });
}

export function getDayNumber(dateStr: string | null | undefined): number {
  const date = parseDate(dateStr);
  return date ? date.getDate() : 0;
}